import apiClient from "../../../api-client";
import getWrappedUseMutation from "../../helpers/getWrappedUseMutation";

export const useDeleteForumTableMutation = getWrappedUseMutation(apiClient.ForumTables.delete);
